export default {
    'CHECK': 'Check',
    'CHECKS': 'Check',
    'PAYPAL': 'PayPal',
    'ACH': 'Direct Deposit / ACH',
    'WIRE': 'Wire Transfer'
}